import { render } from "./PurchaseLogsOverview.vue?vue&type=template&id=054b64e8&scoped=true&ts=true"
import script from "./PurchaseLogsOverview.vue?vue&type=script&lang=ts"
export * from "./PurchaseLogsOverview.vue?vue&type=script&lang=ts"

import "./PurchaseLogsOverview.vue?vue&type=style&index=0&id=054b64e8&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-054b64e8"]])

export default __exports__